<template>
  <div
    class="col-12 col-sm-4 col-md-4 col-lg-3 col-xl-2 m-0 p-0"
    @click.prevent="redirectToProductDetails(product.product_id,product)"
  >
    <div class="product-entry">
      <out-of-stock
        v-if="product.vendor_product_inventories &&
                          product.vendor_product_inventories[0] &&
                        (product.vendor_product_inventories[0].available_stock < 1)"
        :id="'filter-out-of-stock-'+product.product_id"
								:position="position"
      >
      </out-of-stock>
      <div
        class="product-img"
        :class="!(product.vendor_product_inventories &&
                          product.vendor_product_inventories[0]) ||
                        (product.vendor_product_inventories[0].available_stock < 1)?
                        'outofstock-filter':''"
        v-if="product && product.product_details &&
           product.product_details.image_URL_1"
        v-bind:style="{ 'background-image': 'url(' + product.product_details.image_URL_1 + ')' }"
        :id="'filter-pdt-img-'+product.product_id"
								:data-test="'productListTemplatePdtImg'+position"
      >

        <!--<p class="tag" v-if="(position % 2 === 0)">-->
        <!--<span class="new">New Launch</span>-->
        <!--</p>-->
        <!--<p class="tag" v-else>-->
        <!--<span class="sale">Discount Sale</span>-->
        <!--</p> -->
      </div>
      <div class="desc">
        <a
          href
          class="hp-prdt"
										data-test="productListTemplateLink"
										id="productListTemplateLink"
        >
          <h6
            class="hp-prdt-name"
            :id="'filter-pdt-name-'+product.product_id"
												:data-test="'productListTemplatePdtName'+position"
          >
            {{product.product_name}}
          </h6>
          <span class="hp-prdt-spec"
																:data-test="'productListTemplatePdtSpec'+position" id="productListTemplatePdtSpec">
            {{product.product_specification.length > 0 ? product.product_specification[0].value: ''}}
            <!--{{Object.values(product.product_specification).toString()}}-->
          </span>
          <star-rating
            class="plp-stars"
            :star-size="15"
            :show-rating="false"
            :read-only="true"
            v-model="product.review.averageRating"
          >
          </star-rating>
        </a>
        <div
          class="row hp-prdt-product-price"
          :id="'product-price'"
          v-if="product.promotion && product.promotion.promotion_id"
        >
          <div
            :id="'product-price-price'"
            class="hp-prdt-price"
            style="display: inline-block; white-space: nowrap"
												:data-test="'productListTemplatePromoPrice'+position"
          >
            {{product.promotion.promotion_applied_price | currencyConversion}}
          </div>
          <div
            :id="'product-price-discount'"
            class="hp-prdt-og-price"
            style="text-decoration: line-through;
                     display: inline-block;
                     color: gray; white-space: nowrap;"
												:data-test="'productListTemplateDiscountPrice'+position"
          >
            {{product.vpi.price | currencyConversion}}
          </div>

          <div
            :id="'product-price-discount-percent'"
            class="hp-prdt-offer p-0"
            style="display: inline-block; color: rgb(0,128,0);"
            v-if="product.promotion && product.promotion.promotion_id"
												:data-test="'productListTemplatePromoPercent'+position"
          >
            {{product.promotion.promotion_percentage}}% off
          </div>
        </div>
        <div
          class="hp-prdt-price"
          v-else-if="(product.vendor_product_inventories &&
                    product.vendor_product_inventories[0] &&
                    product.vendor_product_inventories[0].price)"
										:data-test="'productListTemplatePrice'+position"
										id="productListTemplatePrice"
        >
          {{product.vendor_product_inventories[0].price | currencyConversion}}
        </div>
      </div>
      <div class="cart-buttons">
        <div
          class="cart"
          @click.stop.prevent
        >
          <p>
            <!--<cart-action-->
            <!--:cartIcon="true"-->
            <!--:product="product"-->
            <!--v-if="!(product.vendor_product_inventories &&-->
            <!--product.vendor_product_inventories[0]) ||-->
            <!--(product.vendor_product_inventories[0].available_stock > 0)"-->
            <!--&gt;</cart-action>-->
            <wish-list
              :wishListIcon="true"
              :product="product"
														:position="position"
            >
            </wish-list>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { customerApi } from '@/services/ApiServices/customerApi'
import OutOfStock from '@/components/widgets/outofstock/OutOfStock'
import WishList from '@/components/actions/wishlist/WishListAction'
import StarRating from 'vue-star-rating'

export default {
	name: 'product-list-template',
	props: {
		product: Object,
		isWishlist: {
			type: Boolean,
			default: false
		},
		position: {
			type: Number,
			default: 0
		}
	},
	components: {
		WishList,
		OutOfStock,
		StarRating
	},
	data () {
		return {
			// promotion_id: '',
		}
	},
	mounted () {
	},
	// beforeRouteEnter(to,next,from){
	//
	//   document.title = to.meta.title;
	//   document.description = to.meta.description;
	// },
	computed: {
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('wishlist', ['isInWishlist']),
		...mapGetters('user', ['isAuthenticated'])
	},
	methods: {
		...mapActions('productselected', [
			'setSelectedProductIdData',
			'setSelectedProductData'
		]),
		...mapActions('recentview', ['setRecentProductsData']),
		...mapActions('cart', ['addToCart']),
		redirectToProductDetails (productId, product) {
			this.setRecentProductsData(productId)
			this.setSelectedProductData(product)
			if (this.isAuthenticated) {
				customerApi
					.insertRecentlyViewedProducts(productId)
			}
			if (
				product.vendor_product_inventories &&
        product.vendor_product_inventories[0] &&
        product.vendor_product_inventories[0].promotional_prices
			) {
				this.$router.push({
					name: 'ProductDetails',
					path: '/product_description',
					query: {
						productName: product.product_name,
						productId: product.product_id,
						productCategoryId: product.product_category_id,
						promotionId:
              product.vendor_product_inventories[0].promotional_prices.promotion_id
					}
				})
			} else {
				this.$router.push({
					name: 'ProductDetails',
					path: '/product_description',
					query: {
						productName: product.product_name,
						productId: product.product_id,
						productCategoryId: product.product_category_id
					},
					meta: {
						description: product.product_id,
						title: product.product_name
					}
				})
			}
		}
	}
	//     router:beforeEach((to, from, next) => {
	//     document.title = to.meta.title
	//     next()
	// })
}
</script>
